import { withI18n } from 'react-i18next';
import TrackingDesktop from './Desktop/';
import TrackingMobile from './Mobile/';

export const pureComponentDesktop = TrackingDesktop;
export const pureComponentMobile = TrackingMobile;
export const Desktop = withI18n()(TrackingDesktop);
export const Mobile = withI18n()(TrackingMobile);
